var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1142_42017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 17.25H10.4999V18.75H16.4999V17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 17.25H7.49988V18.75H8.99988V17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 13.5H10.4999V15H16.4999V13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 13.5H7.49988V15H8.99988V13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 9.75H10.4999V11.25H16.4999V9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 9.75H7.49988V11.25H8.99988V9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1142_42017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.09a98e5ac8382b1bf29ae0056dafa8b9.svg";
export { ForwardRef as ReactComponent };